import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/envago/Button/Button';
import Checkbox from '../../../components/envago/Checkbox/Checkbox';

interface ConsentPanelProps {
    // Audio (TTS + earcons) opt-out right at the start — wired to the persisted mute state, so
    // it defaults to ON for new users and remembers an earlier choice.
    audioEnabled: boolean;
    onAudioEnabledChange: (enabled: boolean) => void;
    onStart: () => void;
}

const ConsentPanel = ({ audioEnabled, onAudioEnabledChange, onStart }: ConsentPanelProps) => {
    const { t } = useTranslation();
    return (
        <div className={'absolute inset-0 bg-black bg-opacity-80 flex items-center justify-center p-4'}>
            <div className={'bg-white rounded-xl p-4 max-w-md w-full'}>
                <h2>{t('aiReading.consent.title')}</h2>
                <p className={'text-sm my-2'}>{t('aiReading.instructions.consent')}</p>
                <p className={'text-xs text-gray-500'}>{t('aiReading.consent.privacyHint')}</p>
                <div className={'mb-3'}>
                    <Checkbox value={audioEnabled} onChange={onAudioEnabledChange} label={t('aiReading.consent.audioLabel')} />
                </div>
                <Button primary={true} block={true} onClick={onStart}>
                    {t('aiReading.buttons.start')}
                </Button>
            </div>
        </div>
    );
};

export default ConsentPanel;
